import { notificationApi } from '@/api'

const state = {
  items: [],
  loading: false,
}

const getters = {
  notifications: (s) => s.items,
  unreadCount: (s) => s.items.filter((n) => !n.read_at).length,
}

const mutations = {
  SET_NOTIFICATIONS(state, items) { state.items = items || [] },
  SET_LOADING(state, val) { state.loading = val },
}

const actions = {
  async fetch({ commit }) {
    if (!localStorage.getItem('token')) return
    try {
      const { data } = await notificationApi.list()
      commit('SET_NOTIFICATIONS', data)
    } catch (_) {
      commit('SET_NOTIFICATIONS', [])
    }
  },
  async markRead({ dispatch }, id) {
    await notificationApi.markRead(id)
    await dispatch('fetch')
  },
  async markAllRead({ dispatch }) {
    await notificationApi.markAllRead()
    await dispatch('fetch')
  },
}

export default { namespaced: true, state, getters, mutations, actions }
